

function getIndex(array, obj) {
    if (array == null) {
        throw new TypeError();
    }

    var i,
        len;

    len = array.length;

    for (i = 0; i < len; i++) {
        if (array[i].equals(obj)) {
            return i;
        }
    }

    return -1;
};

module.exports = getIndex;